<template>
    <div class="modal-open">
        <div class="modal modal-opened" tabindex="-1" role="dialog" aria-hidden="false">
            <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
                <div class="modal-content modal-rounded">
                    <div class="row">
                        <div class="col-md-12" v-html="content" v-if="loaded"></div>
                        <loader v-if="!loaded"></loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Loader from '../../loader/components/Loader';
  import {mapState} from 'vuex';
  import axios from 'axios';

  export default {
    components: {Loader},
    data() {
      return {
        content: null,
        title: 'AutismTech',
        meta_description: null,
        meta_keywords: null,
        loaded: false,
      };
    },
    computed: {
      ...mapState([
        'route',
      ]),
    },
    metaInfo() {
      return {
        title: this.title,
        meta: [
          {name: 'description', content: this.meta_description},
          {name: 'keywords', content: this.meta_keywords},
        ],
      };
    },
    async created() {
      let response = await axios.get(`/page/${this.route.meta.slug}`);
      let {data: page} = response.data;
      for (let key of Object.keys(page)) {
        this[key] = page[key];
      }
      this.loaded = true;
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/page/components/StaticPage.vue